import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { exists, isValidArray } from '../../../helpers';
import Styles from './OptionsInput.styles';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const SelectWrapper = styled.div`${Styles.selectWrapper};`; // prettier-ignore
const Select = styled.select`${Styles.select}`; // prettier-ignore
const Input = styled.input`${Styles.input}`;
const SelectArrow = styled.div`${Styles.selectArrow};`; // prettier-ignore

/**
 * OptionsInput component
 * @param {string} className - modifier class
 * @param {string} defaultValue - default value for select box
 * @param {string} name - input's name
 * @param {string} page - current page
 * @param {Array} options - input's options
 * @param {bool} isSorting - true if it's a sorting select
 * @returns {?JSX}
 */
const OptionsInput = ({
  className,
  time,
  name,
  options,
  onChange,
  value,
  hasBlackTheme,
  isSorting,
  calendar,
  min,
  textColor,
  max,
  inputName,
  page
}) => {
  if (!exists(name) || !isValidArray(options)) return null;

  const freedomPayStyles = {
    borderRadius: '0.25rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    display: 'block',
    fontSize: '1rem',
    fontFamily: 'Arial, sans-serif',
    height: 'calc(2.25rem + 2px)',
    lineHeight: 1.5,
    padding: '0.375rem 0.75rem',
    backgroundColor: 'white',
    //marginBottom: '1rem',
    width: '100%',
    outline: 'none',
  };

  return (
    <Wrapper className={className} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
      <SelectWrapper>
        {!calendar && !time && (
        <Select
          className={hasBlackTheme ? 'cbx-regular' : 'cbx-bold'}
          onChange={onChange}
          value={value}
          hasBlackTheme={hasBlackTheme}
          isSorting={isSorting}
          status={!!value}
          style={page !== 'home' ? freedomPayStyles : {}}
        >
          {options.map(option => (
            <option value={option.value} key={`inputValue${name}${option.value}`}>
              {option.name}
            </option>
          ))}
        </Select>)}
        {calendar && (
          <Input
            name={inputName}
            type="date"
            textColor={textColor}
            className={hasBlackTheme ? 'cbx-regular' : 'cbx-bold'}
            onChange={onChange}
            value={value}
            min={min}
            max={max}
            status={!!value}
            hasBlackTheme={hasBlackTheme}
            isSorting={isSorting}
            style={page !== 'home' ? freedomPayStyles : {}}
          />
        )}
        {!calendar && time && (
          <Input
            name={inputName}
            type="time"
            textColor={textColor}
            className={hasBlackTheme ? 'cbx-regular' : 'cbx-bold'}
            onChange={onChange}
            value={value}
            min={min}
            max={max}
            hasBlackTheme={hasBlackTheme}
            isSorting={isSorting}
            style={page !== 'home' ? freedomPayStyles : {}}
          />
        )}
        {!calendar && <SelectArrow hasBlackTheme={hasBlackTheme} isSorting={isSorting} />}
      </SelectWrapper>
    </Wrapper>
  );
};

OptionsInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  hasBlackTheme: PropTypes.bool,
  isSorting: PropTypes.bool,
  textColor: PropTypes.string,
  calendar: PropTypes.bool,
  time: PropTypes.bool,
  min: PropTypes.string,
  max: PropTypes.string,
  inputName: PropTypes.string,
  page: PropTypes.string
};

export default OptionsInput;
